/* Core & libraries */
import React, { useState } from 'react';

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import { INTERCOM_USERHASH_ENDPOINT } from "../endpoints/endpoints";

/* Components */
/* Styles */

export const useIntercomService = () => {

const [intercomUserHash, setIntercomUserHash] = useState("");

const { genericApiFetch } = useGenericApiFetch();

const getIntercomUserHash = async () => {
    const response = await genericApiFetch({
      url: INTERCOM_USERHASH_ENDPOINT,
      method: "GET",
    });
    if (response.success) {
        setIntercomUserHash(response.data);
      return true;
    }
    return false;
  };

  return {
    intercomUserHash,
    getIntercomUserHash
  };
}